
import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { ApplyComponent } from './apply/apply.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { BlogDetailViewComponent } from './pages/blog-detail-view/blog-detail-view.component';
import { BlogComponent } from './pages/blog/blog.component';
import { CareerComponent } from './pages/career/career.component';
import { ConnectWithUsComponent } from './pages/connect-with-us/connect-with-us.component';
import { ContactusComponent } from './pages/contactus/contactus.component';
import { GetAquoteComponent } from './pages/get-aquote/get-aquote.component';
import { PagenotFoundComponent } from './pages/pagenot-found/pagenot-found.component';
import { PortfolioComponent } from './pages/portfolio/portfolio.component';
import { CmsComponent } from './pages/services/cms/cms.component';
import { ECommerceComponent } from './pages/services/e-commerce/e-commerce.component';
import { FrontEndComponent } from './pages/services/front-end/front-end.component';
import { JsFullStackComponent } from './pages/services/js-full-stack/js-full-stack.component';
import { NftDevelopmentComponent } from './pages/services/nft-development/nft-development.component';
import { ProgressiveWebAppComponent } from './pages/services/progressive-web-app/progressive-web-app.component';
import { WebApplicationComponent } from './pages/services/web-application/web-application.component';
import { AndroidComponent } from './pages/technologies/android/android.component';
import { AngularJsComponent } from './pages/technologies/angular-js/angular-js.component';
import { DotnetComponent } from './pages/technologies/dotnet/dotnet.component';
import { DrupalComponent } from './pages/technologies/drupal/drupal.component';
import { IosComponent } from './pages/technologies/ios/ios.component';
import { JavaComponent } from './pages/technologies/java/java.component';
import { MagentoComponent } from './pages/technologies/magento/magento.component';
import { NodeJsComponent } from './pages/technologies/node-js/node-js.component';
import { PhpComponent } from './pages/technologies/php/php.component';
import { PythonComponent } from './pages/technologies/python/python.component';
import { ReactJsComponent } from './pages/technologies/react-js/react-js.component';
import { RubyonrailComponent } from './pages/technologies/rubyonrail/rubyonrail.component';
import { ShopifyComponent } from './pages/technologies/shopify/shopify.component';
import { VueJsComponent } from './pages/technologies/vue-js/vue-js.component';
import { WoocommerceComponent } from './pages/technologies/woocommerce/woocommerce.component';
import { WordpressComponent } from './pages/technologies/wordpress/wordpress.component';
import { NftEcommerceComponent } from './pages/technologies/nft-ecommerce/nft-ecommerce.component';
import { SearchComponent } from './search/search.component';
import { NftMarketplaceComponent } from './pages/technologies/nft-marketplace/nft-marketplace.component';
import { HomeNewComponent } from './pages/home-new/home-new.component';
import { AndroidJavaComponent } from './pages/services/android-java/android-java.component';
import { HybridIonicComponent } from './pages/services/hybrid-ionic/hybrid-ionic.component';
import { AndroidKotlinComponent } from './pages/services/android-kotlin/android-kotlin.component';
import { IosSwiftComponent } from './pages/services/ios-swift/ios-swift.component';
import { HybridFlutterComponent } from './pages/services/hybrid-flutter/hybrid-flutter.component';
import { FlutterComponent } from './pages/technologies/flutter/flutter.component';
import { IonicComponent } from './pages/technologies/ionic/ionic.component';
import { ReactNativeComponent } from './pages/technologies/react-native/react-native.component';
import { ShopwareComponent } from './pages/technologies/shopware/shopware.component';
import { WixComponent } from './pages/technologies/wix/wix.component';
import { AndroidAppDevelopmentComponent } from './pages/services/android-app-development/android-app-development.component';
import { IosAppDevelopmentComponent } from './pages/services/ios-app-development/ios-app-development.component';
import { ReactNativeComponentServices } from './pages/services/react-native/react-native.component';
import { AugumentedRealityComponent } from './pages/services/augumented-reality/augumented-reality.component';
import { TestingComponentComponent } from './pages/testing-component/testing-component.component';
import { HomeNewUpdateComponent } from './home-new-update/home-new-update.component';
import { CaseStudyComponent } from './pages/case-study/case-study.component';
import { CaseStudyListingComponent } from './pages/case-study-listing/case-study-listing.component';

import { MagentoDevelopmentComponent } from './pages/services/magento-development/magento-development.component'
import { ShopifyDevelopmentComponent } from './pages/services/shopify-development/shopify-development.component';
import { ShopwareDevelopmentComponent } from './pages/services/shopware-development/shopware-development.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { PortfolioNewComponent } from './pages/portfolio-new/portfolio-new.component';
import { PortfolioListingComponent } from './pages/portfolio-listing/portfolio-listing.component';
import { CaseStudyLoveBonitoComponent } from './pages/case-study-love-bonito/case-study-love-bonito.component';
import { CaseStudyCynthiaRowleyComponent } from './pages/case-study-cynthia-rowley/case-study-cynthia-rowley.component';
import { CaseStudyTheBodyshopComponent } from './pages/case-study-the-bodyshop/case-study-the-bodyshop.component';
import { CaseStudyLockwoodUmbrellasComponent } from './pages/case-study-lockwood-umbrellas/case-study-lockwood-umbrellas.component';
import { CaseStudyHnmComponent } from './pages/case-study-hnm/case-study-hnm.component';
import { CaseStudyZonStepsComponent } from './pages/case-study-zon-steps/case-study-zon-steps.component';
import { CaseStudyPetsandJoyComponent } from './pages/case-study-petsand-joy/case-study-petsand-joy.component';
import { CaseStudiesComponent } from './pages/case-studies/case-studies.component';
import { CaseStudyMarcFisherComponent } from './pages/case-study-marc-fisher/case-study-marc-fisher.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AemComponent } from './pages/services/aem/aem.component';
import { YoutubeMarketingServicesComponent } from './pages/services/youtube-marketing-services/youtube-marketing-services.component';
import { HomeNewUsaComponent } from './pages/home-new-usa/home-new-usa.component';
import { microsoftAzureComponent } from './pages/microsoftAzure/microsoftAzure';
import { microsoftNativeComponent } from './pages/microsoftNative/microsoftNative';
import { microsoftBusinessControllerComponent } from './pages/microsoftBusinessController/microsoftBusinessController';
import { microsoftPowerBIComponent } from './pages/microsoftPowerBI/microsoftPowerBI';
import { MicrosoftThreeSixtyFiveComponent } from './pages/microsoftThreeSixtyFive/microsoftThreeSixtyFive';
import { microsoftDynamicComponent } from './pages/microsoftDynamic/microsoftDynamic';
import {SalesforceComponent} from './pages/services/salesforce/salesforce.component'
import {OracleComponent} from './pages/services/oracle/oracle.component'
import { OdooComponent } from './pages/services/odoo/odoo.component';
import { TableauComponent } from './layout/tableau/tableau.component';

import { HubspotComponent } from './layout/hubspot/hubspot.component';
import { AdobeExperiencComponent } from './layout/adobe-experienc/adobe-experienc.component';
import { SAPSolutionsComponent } from './layout/sap-solutions/sap-solutions.component';
import { PrestashopComponent } from './pages/prestashop/prestashop.component';
import { AiSolutionsComponent } from './pages/ai-solutions/ai-solutions.component';

const routes: Routes = [
  { path: '', component: HomeNewUpdateComponent },
  { path: 'home.html', component: HomeNewUpdateComponent },
  { path: 'usa.html', component: HomeNewUsaComponent },
  {
    path: 'about-us.html',
    component : AboutUsComponent
  },
  {
    path: 'ai-solution',
    component: AiSolutionsComponent
  },
  {
    path: 'case-studies/marc-fisher.html',
    component : CaseStudyMarcFisherComponent
  },
  {
    path: 'case-studies.html',
    component : CaseStudiesComponent
  },
  {
    path: 'case-studies/ilastword.html',
    component : CaseStudyComponent
  },
  {
    path: 'case-studies/threndx.html',
    component : CaseStudyListingComponent
  },
  // {
  //   path: 'blog.vidhema.com',
  //   component : BlogComponent
  // },
  {
    path: 'blog',
    component : BlogComponent
  },
  {
    path: 'blog/:category/:page',
    component : BlogComponent
  },
  {
    matcher: (url) => {
      if (url.length === 2 && (/^[0-9]*$/).test(url[1].path)) {
        return {
          consumed: url,
          posParams: {
            id: new UrlSegment(url[1].toString(),{})
          }
        };
      }
      return null;
    },
    component: BlogComponent
  },
  {
    path: 'salesforce-development.html',
    component : SalesforceComponent
    // component: ComingSoonComponent
  },
  {
    path: 'oracle-development.html',
    component : OracleComponent
    // component: ComingSoonComponent
  },
  {
    path:"odoo-development.html",
    component:OdooComponent
  },
  {
    path: 'blog/:url',
    component : BlogDetailViewComponent
    // component: ComingSoonComponent
  },
  {
    path: 'portfolio-detail',
    component: PortfolioNewComponent
  },
  {
    path: 'portfolio-new',
    component: PortfolioListingComponent
  },
  {
    path: 'portfolio.html',
    component : PortfolioListingComponent
  },
  {
    path: 'contact-us.html',
    component : ContactusComponent
  },

   { path:'getaquote.html',
    component:GetAquoteComponent
  },
  {
    path:'ConnectWithUs.html',
    component:ConnectWithUsComponent
  },
  {
    path:'ecommerce-development.html',
    component:ECommerceComponent
  },
  {
    path:'nft-development.html',
    component:NftDevelopmentComponent
  },
  {
    path:'resource-as-a-service.html',
    component:ECommerceComponent
  },
  {
    path:'magento-mobile-app-development.html',
    component:MagentoComponent
  },
  {
    path:'web-application-development.html',
    component:WebApplicationComponent
  },
  {
    path:'progressive-web-app-development.html',
    component:ProgressiveWebAppComponent
  },
  {
    path:'mobile-apps-development.html',
    component:IosAppDevelopmentComponent
  },
  {
    path:'youtube-marketing-services.component.html',
    component:YoutubeMarketingServicesComponent
  },
  {
    path:'front-end-development.html',
    component:FrontEndComponent
  },
  {
    path:'js-based-full-stack-development.html',
    component:JsFullStackComponent
  },
  {
    path:'psd-to-html-development.html',
    component:FrontEndComponent
  },
  {
    path:'cms-development.html',
    component:CmsComponent
  },
  {
    path:'web-design.html',
    component:FrontEndComponent
  },
  {
    path:'dedicated-developer.html',
    component:MagentoComponent
  },
  {
    path:'technologies-web-java.html',
    component:JavaComponent
  },
  {
    path:'technologies-web-dotnet.html',
    component:DotnetComponent
  },
  {
    path:'technologies-web-php.html',
    component:PhpComponent
  },
  {
    path:'technologies-web-rubyonrails.html',
    component:RubyonrailComponent
  },
  {
    path:'technologies-web-python.html',
    component:PythonComponent
  },
  {
    path:'technologies-mobile-android.html',
    component:AndroidComponent
  },
  {
    path:'technologies-mobile-ios.html',
    component:IosComponent
  },
  {
    path:'technologies-mobile-phonegap.html',
    redirectTo:'hire-ionic-developers.html',

  },
  {
    path:'technologies-mobile-xamarin.html',
    component:ProgressiveWebAppComponent
  },
  {
    path:'technologies-ecommerce-magento.html',
    component:MagentoComponent
  },
  {
    path:'technologies-ecommerce-opencart.html',
    component:ECommerceComponent
  },
  {
    path:'technologies-ecommerce-woocommerce.html',
    component:WoocommerceComponent
  },
  {
    path:'technologies-ecommerce-nopcommerce.html',
    component:ECommerceComponent
  },
  {
    path:'technologies-ecommerce-prestashop.html',
    component:ECommerceComponent
  },
  {
    path:'technologies-ecommerce-shopify.html',
    component:ShopifyComponent
  },
  {
    path:'technologies-cms-wordpress.html',
    component:WordpressComponent
  },
  {
    path:'technologies-cms-drupal.html',
    component:DrupalComponent
  },
  {
    path:'technologies-cms-umbraco.html',
    component:CmsComponent
  },
  {
    path:'technologies-cms-sitefinity.html',
    component:CmsComponent
  },
  {
    path:'technologies-cms-kentico.html',
    component:CmsComponent
  },
  {
    path:'technologies-javascript-vue-js.html',
    component:VueJsComponent
  },
  {
    path:'technologies-javascript-angular-js.html',
    component:AngularJsComponent
  },
  {
    path:'technologies-javascript-node-js.html',
    component:NodeJsComponent
  },
  {
    path:'technologies-javascript-react-js.html',
    component:ReactJsComponent
  },
  {
    path:'technologies-javascript-react-js.html',
    component:ReactJsComponent
  },
  {
    path:'technologies-nft-ecommerce.html',
    component: NftEcommerceComponent
  },
  {
    path:'technologies-nft-marketplace.html',
    component: NftMarketplaceComponent
  },
  {
    path:'career.html',
    component:CareerComponent
  },
  // {
  //   path:'career',
  //   component:ComingSoonComponent
  // },
  {
    path:'notfound',
    component:PagenotFoundComponent
  },
  {
    path:'apply/:name',
    component:ApplyComponent
  },
  {
    path:'search/:name',
    component:SearchComponent
  },
  {
    path:'home-new',
    component: HomeNewComponent
  },
  {
    path:'android-java-development.html',
    component: AndroidJavaComponent
  },
  {
    path: 'ionic-development.html',
    component: HybridIonicComponent
  },
  {
    path:'hubspot.html',
    component: HubspotComponent
  },
  {
    path: 'flutter-development.html',
    component: HybridFlutterComponent
  },
  {
    path: 'hybrid-flutter-development.html',
    redirectTo:'flutter-development.html'
  },
  {
    path: 'work-with-us.html',
    redirectTo:'about-us.html'
  },
  {
    path: 'blog/5/blog/what-is-the-laravel-framework-and-how-does-it-work',
    redirectTo:'about-us.html'
  },
{
    path: 'Resource-As-a-Service',
    redirectTo:'about-us.html'
  },
  {
    path: 'api.vidhema.com/',
    redirectTo:'vidhema.com/'
  },

  {
    path: 'frontend-development.html',
    redirectTo:'front-end-development.html'
  },

  {
    path: 'work-with-us.html',
    redirectTo:'about-us.html'
  },

  {
    path: 'android-o-beta-is-available-now',
    redirectTo:'android-app-development.html'
  },

  {
    path: 'frontend-development.html',
    redirectTo:'front-end-development.html'
  },

  {
    path: 'blog/33',
    redirectTo:'blog'
  },

  {
    path: 'ecommerce-development.html',
    redirectTo:'ecommerce-development.html'
  },

  {
    path: 'technologies-Virtual-Reality-Game-Development.html',
    redirectTo:'augumented-reality.html'
  },

  {
    path: 'how-to-spare-extra-dollars-when-building-a-mobile-app',
    redirectTo:'How-Much-Money-Can-You-Earn-with-An-App.html'
  },

  {
    path: 'technologies-ecommerce-mag',
    redirectTo:'ecommerce-development.html'
  },

  {
    path: 'blog-cat',
    redirectTo:'blog'
  },

  {
    path: 'enterprises-start-building-progressive-web-apps/',
    redirectTo:'progressive-web-app-development.html'
  },

  {
    path: 'consulting-services',
    redirectTo:'contact-us.html'
  },

  {
    path: 'hr@vidhema.com',
    redirectTo:'contact-us.html'
  },

  {
    path: 'blog/27/http:/vidhema.com/blog/Tips-on-How-to-Design-The-Perfect-Email-Newsletter',
    redirectTo:'blog'
  },

  {
    path: '6-reasons-node-js-is-your-express-ticket-to-web-app-development',
    redirectTo:'top-6-tools-for-node-js-development'
  },

  {
    path: 'skype:vidhema.solution',
    redirectTo:'contact-us.html'
  },

  {
    path: 'what-is-the-laravel-framework-and-how-does-it-work',
    redirectTo:'PHP-Laravel-Framework.html'
  },

  {
    path: 'contact.html',
    redirectTo:'contact-us.html'
  },

  {
    path: 'contact.html',
    redirectTo:'contact-us.html'
  },

  {
    path: 'henderson',
    redirectTo:'getaquote.html'
  },

  {
    path: 'anoop-singh',
    redirectTo:'getaquote.html'
  },

  {
    path: 'slider-3',
    redirectTo:'vidhema.com'
  },

  {
    path: 'what-is-SEO?',
    redirectTo:'How-SEO-can-increase-conversion-rates-for-eCommerce-businesses'
  },

  {
    path: 'get-a-quote',
    redirectTo:'getaquote.html'
  },

  {
    path: 'fullstack-web-developer-nodejs.html',
    redirectTo:'front-end-development.html'
  },

  {
    path: 'twarita-verma',
    redirectTo:'getaquote.html'
  },

  {
    path: 'anoop-singh',
    redirectTo:'getaquote.html'
  },

  {
    path: 'professional-code-is-core-power',
    redirectTo:'getaquote.html'
  },

  {
    path: 'hello-world',
    redirectTo:'contact-us.html'
  },

  {
    path: '.html',
    redirectTo:'index.html'
  },

  {
    path: 'uncategorized',
    redirectTo:'career.html'
  },

  {
    path: '80',
    redirectTo:'career.html'
  },

  {
    path: 'hr@vidhema.com',
    redirectTo:'contact-us.html'
  },

  {
    path: 'magento2-CE-Developer-PHP.html',
    redirectTo:'hire-magento-developers.html'
  },

  {
    path: 'fullstack-web-developer-php.html',
    redirectTo:'front-end-development.html'
  },

  {
    path: 'sales@vidhema.com',
    redirectTo:'mailto:sales@vidhema.com?Subject=Hello%20again'
  },

  {
    path: '2017/05/26/design-logo/',
    redirectTo:'index.html'
  },

  {
    path: 'progressive-web-apps/',
    redirectTo:'progressive-web-app-development.html'
  },

  {
    path: '2017/05/26/design-logo/',
    redirectTo:'index.html'
  },

  {
    path: '2017/05/26/typography/',
    redirectTo:'index.html'
  },

  {
    path: 'about',
    redirectTo:'about-us.html'
  },

  {
    path: 'mobile-apps-development',
    redirectTo:'about-us.html'
  },

  {
    path: 'contact-us',
    redirectTo:'contact-us.html'
  },

  {
    path: 'portfolio',
    redirectTo:'portfolio.html'
  },

  {
    path: '2017/05/26/ios-apps',
    redirectTo:'hire-ios-developers.html'
  },


  {
    path: 'services',
    redirectTo:'web-application-development.html'
  },

  {
    path: '2017/05/25/slider-one',
    redirectTo:'getaquote.html'
  },

  {
    path: '2017/05/25/slider-one/',
    redirectTo:'getaquote.html'
  },

  {
    path: 'skype:vidhema.solution',
    redirectTo:'contact-us.html'
  },

  {
    path: '2017/05/26/mountain/',
    redirectTo:'contact-us.html'
  },

  {
    path: 'avinash-verma',
    redirectTo:'getaquote.html'
  },

  {
    path: 'slider-one',
    redirectTo:'getaquote.html'
  },

  {
    path: '2017/05/25/victoria-joe-lead-support/',
    redirectTo:'getaquote.html'
  },

  {
    path: 'design-logo',
    redirectTo:'index.html'
  },

  {
    path: 'solutions.html',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'technologies-Oculus-Rift-Game-Development.html',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'technologies-HTC-Vive-Game-Development.html',
    redirectTo:'https://vidhema.com/'
  },


  {
    path: 'blog/1/blog/what-is-the-laravel-framework-and-how-does-it-work',
    redirectTo:'blog'
  },

  {
    path: 'technologies-Virtual-Reality-Game-Development.html',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'India$25-$4910-492016Mobile',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'technologies-Oculus-Rift-Game-Development.html',
    redirectTo:'https://vidhema.com/'
  },


  {
    path: 'iot-will-next-big-thing-2017?utm_content=bufferfa459&utm_medium=social&utm_source=twitter.com&utm_campaign=buffer',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'iot-will-next-big-thing-2017/',
    redirectTo:'https://vidhema.com/'
  },


  {
    path: 'blog/18/http:/vidhema.com/blog/Tips-on-How-to-Design-The-Perfect-Email-Newsletter',
    redirectTo:'blog'
  },


  {
    path: '2017/05/25/professional-code-is-core-power/',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'slider-one/',
    redirectTo:'getaquote.html'
  },

  {
    path: 'service/ecommerce-solutions/',
    redirectTo:'ecommerce-development.html'
  },

  {
    path: 'technologies-Unity-Game-Development.html',
    redirectTo:'https://vidhema.com/'
  },

  {
    path: 'android-kotlin-development.html',
    component: AndroidKotlinComponent
  },
  {
    path: 'ios-swift-development.html',
    component: IosSwiftComponent
  },
  // Hire Developer Start
  {
    path: 'hire-java-developers.html',
    component: JavaComponent,
  },
  {
    path: 'hire-dotnet-developers.html',
    component:DotnetComponent
  },
  {
    path:'hire-php-developers.html',
    component:PhpComponent
  },
  {
    path:'hire-python-developers.html',
    component:PythonComponent
  },
  {
    path:'hire-android-developers.html',
    component:AndroidComponent
  },
  {
    path:'hire-ios-developers.html',
    component:IosComponent
  },
  {
    path: 'hire-flutter-developers.html',
    component: FlutterComponent
  },
  {
    path: 'hire-ionic-developers.html',
    component: IonicComponent
  },
  {
    path: 'hire-react-native-developers.html',
    component: ReactNativeComponent
  },
  {
    path:'hire-magento-developers.html',
    component:MagentoComponent
  },
  {
    path:'hire-woocommerce-developers.html',
    component:WoocommerceComponent
  },
  {
    path:'hire-shopify-developers.html',
    component:ShopifyComponent
  },
  {
    path: 'hire-shopware-developers.html',
    component: ShopwareComponent
  },
  {
    path:'hire-wordpress-developers.html',
    component:WordpressComponent
  },
  {
    path:'hire-drupal-developers.html',
    component:DrupalComponent
  },
  {
    path: 'hire-wix-developers.html',
    component: WixComponent
  },
  {
    path:'hire-vue-js-developers.html',
    component:VueJsComponent
  },
  {
    path:'hire-angular-js-developers.html',
    component:AngularJsComponent
  },
  {
    path:'hire-node-js-developers.html',
    component:NodeJsComponent
  },
  {
    path:'hire-react-js-developers.html',
    component:ReactJsComponent
  },
  {
    path:'hire-nft-ecommerce-developers.html',
    component: NftEcommerceComponent
  },
  {
    path:'hire-nft-marketplace-developers.html',
    component: NftMarketplaceComponent
  },
  //Hire Developer End
  {
    path: 'android-app-development.html',
    component: AndroidAppDevelopmentComponent
  },
  {
    path: 'aem-cms-development.html',
    component: AemComponent
  },
  {
    path: 'ios-app-development.html',
    component: IosAppDevelopmentComponent
  },
  {
    path: 'react-native.html',
    component: ReactNativeComponentServices
  },
  {
    path: 'augumented-reality.html',
    component: AugumentedRealityComponent
  },
  {
    path: 'testing-component.html',
    component: TestingComponentComponent
  },
  {
    path: 'magento-development.html',
    component: MagentoDevelopmentComponent
  },
  {
    path: 'shopify-development.html',
    component: ShopifyDevelopmentComponent
  },
  {
    path: 'shopware-development.html',
    component: ShopwareDevelopmentComponent
  },
  {
    path:'case-studies/love-bonito.html',
    component:CaseStudyLoveBonitoComponent
  },
  {
    path:'case-studies/cynthia-rowley.html',
    component: CaseStudyCynthiaRowleyComponent
  },
  {
    path:'case-studies/thebodyshop.html',
    component: CaseStudyTheBodyshopComponent
  },
  {
    path:'case-studies/lockwood-umbrellas.html',
    component:CaseStudyLockwoodUmbrellasComponent
  },


{
path:'case-studies-h-and-m',
component:CaseStudyHnmComponent
},

{
  path:'case-studies/zonsteps.html',
  component:CaseStudyZonStepsComponent
},

{
  path:'case-studies/pets-and-joys.html',
component:CaseStudyPetsandJoyComponent

},
{
  path:'privacy-policy.html',
component:PrivacyPolicyComponent

},

{
  path:'microsoft-365.html',
component:MicrosoftThreeSixtyFiveComponent
},
{
  path:'microsoft-azure.html',
component:microsoftAzureComponent
},
{
  path:'microsoft-dynamic.html',
component:microsoftDynamicComponent
},
{
  path:'microsoft-native.html',
component:microsoftNativeComponent
},
{
  path:'microsoft-business-controller.html',
component:microsoftBusinessControllerComponent
},
{
  path:'microsoft-power-bi.html',
component:microsoftPowerBIComponent
},
{
  path:'tableau.html',
component:TableauComponent
},


{
  path:'adobe-experience.html',
component:AdobeExperiencComponent
},
{
  path:'sap-solution.html',
component:SAPSolutionsComponent
},
{
  path:'prestashop.html',
component:PrestashopComponent
},


  {
    path:'**',
    component:PagenotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
